<template>
	<div id="app" @mousemove="handleMouseMove">
		<div class="nav-container" :class="{ 'header--hidden': showNavbar }" :style="`background-image: `+bgcolor+`;`">
			<div class="flex-row-spacebetween-center" style="width: 100%;height: 100%;">
				<div v-if="pageWidth > 768" class="flex-row-spacebetween-center" style="flex: 1;height: 100%;">
					<img src="./assets/logo_temp.png" style="width: 180px;height: auto;" />
					<div class="flex-row-end-center" style="flex: 1;height: 100%;">
						<div class="flex-row-center-center" @click="navIndex=0" @mouseenter="mouseIndex=0"
							@mouseleave="mouseIndex=null" style="margin: 0 20px;">
							<span href="/" @click="handleRoute('/', 0)" class="t7Font whiteColor flex-row-center-center clickable"
								:class="{ 'nav-active': navIndex === 0 }">首页</span>
						</div>
						<div v-for="(channel, cidx) in channels" :key="channel.id" class="flex-row-center-center"
							@mouseenter="mouseIndex = cidx + 1" @mouseleave="mouseIndex = null" style="margin: 0 20px;">
							<span @click="goChannel(channel, cidx + 1)"
								class="t7Font whiteColor flex-row-center-center clickable"
								:class="{ 'nav-active': navIndex === cidx + 1 }">{{ channel.channelName || channel.name }}</span>
						</div>

					</div>
				</div>
				<div v-else class="flex-row-start-center" style="flex: 1;height: 100%;">
					<img src="./assets/logo_temp.png" style="width: 150px;height: auto;" />
					<div class="flex-row-end-center" style="flex: 1;height: 100%;">
						<div class="flex-row-end-center" style="width: 40px;height: 40px;"
							@click="clickMenu=!clickMenu">
							<img v-if="clickMenu" src="../src/assets/home_cha.png" style="width: 24px;height: auto;" />
							<img v-else src="../src/assets/home_caidan.png" style="width: 24px;height: auto;" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="clickMenu" class="whiteBgColor flex-column-start-center"
			style="height: 100vh;width: 100%;z-index: 99999;top: 60px;position: fixed;left: 0;">
			<div class="flex-row-start-center"
				style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;">
				<span class="t7Font" @click="handleRoute('/', 0)"
					style="width: 100%;height: 100%;color: #b68f51;">首页</span>
			</div>
			<div v-for="(channel, cidx) in channels" :key="channel.id" class="flex-row-start-center"
				style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;">
				<span class="t7Font" @click="goChannel(channel, cidx + 1)"
					style="width: 100%;height: 100%;color: #b68f51;">{{ channel.channelName || channel.name }}</span>
			</div>

		</div>
		<keep-alive>
			<!-- 只缓存带有 keepAlive 标记的组件 -->
			<router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
		</keep-alive>

		<!-- 不缓存的组件 -->
		<router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
	import {
		getapinewschannellist
	} from './api/manageMent.js'
	export default {
		name: 'app',
		components: {

		},
		data() {
			return {
				oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
				scrollTop: 0, // 记录当前的滚动距离
				bgcolor: 'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))!important;',
				tran_flag: true,
				showNavbar: false,
				fade: '',
				index: 0,
				mouseIndex: null,
				mousechiIndex: null,
				pageWidth: window.innerWidth,
				clickMenu: false,
				clickMenuIndex: 0,
				activeMenu: '', // 当前高亮的一级菜单
				navIndex: 0, //导航栏选中的下标
				channels: [], //顶部动态栏目菜单
			}
		},
		created() {
			console.log('进入主页', window.location.href);
			this.clickMenu = false
			this.clickMenuIndex = 0
			this.getChannels()
			if (window.location.href.includes('store')) {
				this.index = 1
			} else if (window.location.href.includes('dishes')) {
				this.index = 2
			} else if (window.location.href.includes('shop')) {
				this.index = 3
			} else if (window.location.href.includes('connectUs')) {
				this.index = 4
			} else if (window.location.href.includes('brandIntroduction')) {
				this.index = 5
			} else {
				this.index = 0
			}
		},
		watch: {
			// scrollTop(newValue, oldValue) {
			// 	setTimeout(() => {
			// 		if (newValue == window.scrollY) { //延时执行后当newValue等于window.scrollY，代表滚动结束
			// 			console.log('滚动结束');
			// 			this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
			// 			this.tran_flag = true;
			// 		};
			// 	}, 300); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
			// 	if (this.oldScrollTop == oldValue) { //每次滚动开始时oldScrollTop与oldValue相等
			// 		console.log('滚动开始');
			// 		this.tran_flag = false;
			// 	}
			// }
		},

		mounted() {
			// window.addEventListener('scroll', this.handleScroll);
			// window.addEventListener('resize', this.handleResize);
			document.title = '宏铭高考志愿填报';
		},
		beforeDestroy() {
			// window.removeEventListener('scroll', this.handleScroll);
			// window.removeEventListener('resize', this.handleResize);
		},
		methods: {
			// 获取顶部动态栏目菜单
			getChannels() {
				getapinewschannellist({ pageNum: 1, pageSize: 100 }).then((res) => {
					console.log('顶部栏目=', res);
					this.channels = res.data || []
				});
			},
			// 点击栏目菜单，跳转到对应栏目的新闻列表
			goChannel(channel, index) {
				this.navIndex = index;
				this.$router.push('/news?type=' + channel.id + '&name=' + encodeURIComponent(channel.channelName || channel.name || ''));
				this.clickMenu = false;
			},
			bindJump() {
				this.navIndex = 7;
				const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
				if (isLoggedIn) {
					this.$router.push("/LoginHomeView");
				} else {
					this.$router.push("/Login");
				}
				this.clickMenu = false;
			},
			handleResize() {
				this.pageWidth = window.innerWidth;
				if (this.pageWidth < 1005) {
					this.clickMenu = false
					this.clickMenuIndex = 0
				}
			},
			dropdownChange1(e) {
				// this.$message('click on item ' + e);
				if (!e && this.mouseIndex == 1) {
					this.mouseIndex = null
				}
			},
			dropdownChange2(e) {
				// this.$message('click on item ' + e);
				if (!e && this.mouseIndex == 2) {
					this.mouseIndex = null
				}
			},
			handleScroll() {
				const currentScrollTop = document.documentElement.scrollTop
				this.scrollTop = currentScrollTop
				// if (currentScrollTop > this.oldScrollTop) {
				// 	this.showNavbar = true
				// } else {
				// 	this.showNavbar = false
				// }
				if (currentScrollTop > 0) {
					this.showNavbar = true
					this.mouseIndex = null
				} else {
					this.showNavbar = false
				}
			},
			handleMouseMove(event) {
				// 检查鼠标是否在顶部区域（比如顶部60像素内）
				if (event.clientY <= 60) {
					this.showNavbar = false
				} else {
					if (this.scrollTop > 0) {
						this.showNavbar = true
					}
				}
			},
			handleCommand(menuName, command) {
				console.log("***handleCommand:", menuName, command);
				// 改变高亮
				this.activeMenu = menuName;
				this.navIndex = 2;
        this.$router.push(command);
			},
			handleRoute(path, index) {
				this.navIndex = index;
				this.$router.push(path);
				this.clickMenu = false;
			},
			pushHome() {},
			pushStore() {},
			pushUs() {},
		}
	}
</script>

<style>
	@import "../common/css/common.css";

	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	* {
		margin: 0;
		padding: 0;
		border: 0;
	}

	html,
	body,
	* {
		/* cursor: url('./assets/shubiao.png'), default; */
		/* cursor: pointer; */
	}

	.nav-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 60px;
		padding: 0 10px;
		box-sizing: border-box;
		transition: opacity 0.5s ease-in-out;
		z-index: 9999;
	}

	.header--hidden {
		opacity: 0;
		pointer-events: none;
	}

	.no-border {
		border: none;
	}

	.el-menu {
		transition: all 0.3s;
	}

	.el-menu.el-menu--horizontal {
		border: none;
	}

	::-webkit-scrollbar {
		width: 0 !important;
	}

	::-webkit-scrollbar {
		width: 0 !important;
		height: 0;
	}

	/* 消除小三角 */
	/* .el-popper[x-placement^=bottom] .popper__arrow {
		border: none;
	}

	.el-popper[x-placement^=bottom] .popper__arrow::after {
		border: none;
	} */

	/* .expand-enter-active,
	.expand-leave-active {
		transition: all 0.5s ease;
	} */

	.el-dropdown-link {
		cursor: pointer;
		color: white;
		font-size: 19px;
		/* font-weight: bold; */
		padding-left: 8px;
		padding-right: 8px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.nav-active {
		color: #409EFF !important;
		/* font-weight: bold; */
	}

	/* 全局样式文件：styles.css 或 App.vue 的全局样式 */
	.global-center-message {
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		position: fixed !important;
		z-index: 999999 !important;
	}

	/* 如果需要所有消息都在中间 */
	.el-message {
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		position: fixed !important;
	}

</style>